var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "feedback-page" }, [
    _c(
      "div",
      { staticClass: "page-head" },
      [
        _c("van-icon", {
          staticClass: "back",
          attrs: { name: "arrow-left" },
          on: {
            click: function($event) {
              return _vm.$router.back()
            }
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("m.problem_feedback")))
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content" },
      [
        _c(
          "van-form",
          { staticClass: "feedback-form", on: { submit: _vm.onSubmit } },
          [
            _c("div", { staticClass: "UnableToRecharge" }, [
              _c("div", [_vm._v(_vm._s(_vm.$t("m.problem_description")))]),
              _vm._v(" "),
              _c("div", { staticClass: "rechargeResion" }, [
                _vm._v(_vm._s(_vm.$t("m.unable_recharge")))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tips-box" }, [
              _c("div", { staticClass: "tips-item" }, [
                _c("div", { staticClass: "failureMessage" }, [
                  _c("span", { staticClass: "exclamationMark" }, [_vm._v("!")]),
                  _vm._v(
                    "\n           " +
                      _vm._s(_vm.failureMessage) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "tips-time" }, [
                  _vm._v(_vm._s(_vm.currentTime))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("van-field", {
              staticClass: "questionDescribe",
              attrs: {
                type: "textarea",
                rows: "4",
                placeholder: _vm.$t("m.problem_description_placeholder"),
                maxlength: "1000"
              },
              model: {
                value: _vm.detail,
                callback: function($$v) {
                  _vm.detail = $$v
                },
                expression: "detail"
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "uploader-area" },
              [
                _c("div", { staticClass: "uploader-label" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("m.problem_screenshot", {
                        msg: _vm.$t("m.optional")
                      })
                    )
                  )
                ]),
                _vm._v(" "),
                _c("van-uploader", {
                  attrs: {
                    "after-read": _vm.afterRead,
                    "file-list": _vm.fileList,
                    multiple: "",
                    accept: "image/*,video/*",
                    "max-count": 3
                  },
                  on: { delete: _vm.deleteFile }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "uploader-label" }, [
              _vm._v(_vm._s(_vm.$t("m.contact_information")))
            ]),
            _vm._v(" "),
            _c("van-field", {
              staticClass: "emailWrapper",
              attrs: { placeholder: _vm.$t("m.fill_in_email_address") },
              model: {
                value: _vm.email,
                callback: function($$v) {
                  _vm.email = $$v
                },
                expression: "email"
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "submit-wrap" },
              [
                _c(
                  "van-button",
                  {
                    staticClass: "submitButton",
                    attrs: { "native-type": "submit", type: "primary" },
                    on: { click: _vm.onSubmitClick }
                  },
                  [_vm._v(_vm._s(_vm.$t("m.submit")))]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "notice" }, [
              _vm._v(_vm._s(_vm.$t("m.order_exception_notice")))
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1445e589", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1445e589","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","audio":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/feedback.vue
// module id = null
// module chunks = 